import {app} from '../../app';
import 'marked';
import IComponentController = angular.IComponentController;

export class StaticQuestionPreviewComponent {

    public question:IQuestion;
    public value:string;

    static $inject = [];

    constructor() {

    }

}

app.component('staticQuestionPreview', {
    templateUrl: 'templates/components/questionPreviews/staticQuestionPreview.html',
    controller: StaticQuestionPreviewComponent,
    controllerAs: 'staticQuestionPreview',
    bindings: {
        question: '<',
    }
});